import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import React, { FC } from 'react';

interface WhatsappActionProps {
  waUrl: string;
}
const WhatsappAction: FC<WhatsappActionProps> = ({ waUrl }) => {
  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noreferrer"
      className="rounded-full "
      title="Enviar WhatsApp"
      style={{
        backgroundColor: '#25D366',
        color: '#ffffff',
        width: '19px',
        height: '19px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #25D366'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = '#25D366';
        e.currentTarget.style.borderColor = '#ffffff';
        e.currentTarget.style.backgroundColor = '#ffffff';
        e.currentTarget.style.border = '1px solid #25D366';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = '#ffffff';
        e.currentTarget.style.borderColor = '#ffffff';
        e.currentTarget.style.backgroundColor = '#25D366';
        e.currentTarget.style.border = '1px solid #25D366';
      }}
    >
      <FontAwesomeIcon
        icon={faWhatsapp}
        style={{ fontSize: '16px' }}
      />
    </a>
  );
};

export default WhatsappAction;
